import { delay } from 'lodash-es';

interface ComposeParams {
  subject?: string;
  body?: string | null;
  triggerAction?: Intercom_.IntercomCommand;
}

export function composeIntercomMessage({
  subject = 'I encountered an error',
  body = '',
  triggerAction = 'showNewMessage',
}: ComposeParams = {}): void {
  const { hide_intercom_launcher } = window.BOOTSTRAPPED_DATA;
  if (isIntercomAvailable() && !hide_intercom_launcher) {
    Intercom(triggerAction, subject);
  }
}

export const isIntercomAvailable = () => {
  return typeof Intercom === 'function';
};

export const showNewIntercomMessage = (): boolean => {
  if (isIntercomAvailable()) {
    Intercom('showNewMessage');
    return true;
  }
  return false;
};

/**
 * An update call simulates a page refresh, causing Intercom
 * to check for any new messages or tours to send to the customer.
 */
export const forceIntercomPing = (secondsDelay: number): void => {
  if (!isIntercomAvailable()) return;

  delay(() => {
    Intercom('update', {
      last_request_at: new Date().getTime() / 1000,
    });
  }, secondsDelay * 1000);
};

export const startProductTour = (id: number) => {
  if (isIntercomAvailable()) {
    Intercom('startTour', id);
  }
  return;
};
